import { NOTIFICATION_TYPES } from "@/constants/notification-types";
import { useTranslation } from "react-i18next";
import { StyleProp, ViewStyle } from "react-native";
import { ThemedText } from "./ThemedText";
import { ThemedView } from "./ThemedView";

type EventTypeBadgeProps = {
  eventType: string;
  style?: StyleProp<ViewStyle>;
};

export function EventTypeBadge({ eventType, style }: EventTypeBadgeProps) {
  const { t } = useTranslation();
  const type =
    NOTIFICATION_TYPES[eventType as keyof typeof NOTIFICATION_TYPES];
  if (!type) return null;

  return (
    <ThemedView
      style={[
        {
          borderWidth: 1,
          borderColor: type.severity.border,
          backgroundColor: type.severity.background,
          borderRadius: 6,
          paddingVertical: 2,
          paddingHorizontal: 8,
          alignItems: "center",
          justifyContent: "center",
        },
        style,
      ]}
    >
      <ThemedText
        style={{
          color: type.severity.text,
          fontSize: 12,
          fontWeight: "600",
        }}
      >
        {t(type.title)}
      </ThemedText>
    </ThemedView>
  );
}
